const lxConfig = {
  pv: 'c_fsp_dcep_8deeogfk',
  mv_reward: 'b_fsp_dcep_9lzqm2db_mv',
  mc_reward: 'b_fsp_dcep_9lzqm2db_mc',
  mv_middle_download: 'b_fsp_dcep_kmh5cl3g_mv',
  mc_middle_download: 'b_fsp_dcep_kmh5cl3g_mc',
  mv_bottom_download: 'b_fsp_dcep_l9nirweg_mv',
  mc_bottom_download: 'b_fsp_dcep_l9nirweg_mc',
  mv_detail_step: 'b_fsp_dcep_6czfqpy5_mv',
  mc_detail_step: 'b_fsp_dcep_6czfqpy5_mc',
};

export { lxConfig };
